import { IntervalAction } from '@cgs/wge';

export class AwaitableAction extends IntervalAction {
  private _isFinished: boolean = false;

  constructor(future: Promise<any>) {
    super();
    future.then(() => {
      this._isFinished = true;
    });
  }

  public get isFinished(): boolean {
    return this._isFinished;
  }

  public beginImpl(): void {}

  public endImpl(): void {}

  public updateImpl(_: number): void {}
}
